import { createColorClasses } from "@/theme/colors";
import { IconProps } from "@/types";
import clsx from "clsx";

export const Filters = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "Filters",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.2 1H18.8C19.4627 1 20 1.53725 20 2.2V3.8C20 4.46275 19.4627 5 18.8 5H1.2C0.537262 5 0 4.46274 0 3.8V2.2C0 1.53726 0.537258 1 1.2 1ZM1.2 8H18.8C19.4627 8 20 8.53725 20 9.2V10.8C20 11.4627 19.4627 12 18.8 12H1.2C0.537264 12 0 11.4627 0 10.8V9.2C0 8.53726 0.53726 8 1.2 8ZM1.2 15H18.8C19.4627 15 20 15.5373 20 16.2V17.8C20 18.4627 19.4627 19 18.8 19H1.2C0.537264 19 0 18.4627 0 17.8V16.2C0 15.5373 0.53726 15 1.2 15ZM1 2.2C1 2.08954 1.08954 2 1.2 2H18.8C18.9105 2 19 2.08954 19 2.2V3.8C19 3.91046 18.9105 4 18.8 4H1.2C1.08954 4 1 3.91046 1 3.8V2.2ZM1 9.2C1 9.08954 1.08954 9 1.2 9H18.8C18.9105 9 19 9.08954 19 9.2V10.8C19 10.9105 18.9105 11 18.8 11H1.2C1.08954 11 1 10.9105 1 10.8V9.2ZM1.2 16C1.08954 16 1 16.0895 1 16.2V17.8C1 17.9105 1.08954 18 1.2 18H18.8C18.9105 18 19 17.9105 19 17.8V16.2C19 16.0895 18.9105 16 18.8 16H1.2Z"
        fill="#0066CC"
      />
      <path
        d="M17 17C17 18.6569 15.6569 20 14 20C12.3431 20 11 18.6569 11 17C11 15.3431 12.3431 14 14 14C15.6569 14 17 15.3431 17 17Z"
        fill="white"
      />
      <path
        d="M9 10C9 11.6569 7.65685 13 6 13C4.34315 13 3 11.6569 3 10C3 8.34315 4.34315 7 6 7C7.65685 7 9 8.34315 9 10Z"
        fill="white"
      />
      <path
        d="M17 3C17 4.65685 15.6569 6 14 6C12.3431 6 11 4.65685 11 3C11 1.34315 12.3431 0 14 0C15.6569 0 17 1.34315 17 3Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 19C15.1046 19 16 18.1046 16 17C16 15.8954 15.1046 15 14 15C12.8954 15 12 15.8954 12 17C12 18.1046 12.8954 19 14 19ZM6 12C7.10457 12 8 11.1046 8 10C8 8.89543 7.10457 8 6 8C4.89543 8 4 8.89543 4 10C4 11.1046 4.89543 12 6 12ZM14 5C15.1046 5 16 4.10457 16 3C16 1.89543 15.1046 1 14 1C12.8954 1 12 1.89543 12 3C12 4.10457 12.8954 5 14 5ZM14 6C15.6569 6 17 4.65685 17 3C17 1.34315 15.6569 0 14 0C12.3431 0 11 1.34315 11 3C11 4.65685 12.3431 6 14 6ZM9 10C9 11.6569 7.65685 13 6 13C4.34315 13 3 11.6569 3 10C3 8.34315 4.34315 7 6 7C7.65685 7 9 8.34315 9 10ZM17 17C17 18.6569 15.6569 20 14 20C12.3431 20 11 18.6569 11 17C11 15.3431 12.3431 14 14 14C15.6569 14 17 15.3431 17 17Z"
        fill="#0066CC"
      />
    </svg>
  );
};
